/** @module csi/table/ToolbarFilmStripGroup */
define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/locale",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPlugin",
	"csi/widget/Select"
], function(lang,def,Action,locale,PluginFactory,ToolbarPlugin,Select) {

	return PluginFactory.declare("FilmStripGroup", [Select,ToolbarPlugin], {
		"class": "csi-float-right",
		
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {m_id: "ViewGroup"});
		},

		/**
		 * @override
		 * Only available if widget has filmstripPluginStore defined
		 */
		validatePlugin: function(ctx) {
			return !!ctx.view.filmstripPluginStore;
		},
		
		/**
		 * @override
		 * Show/hide plugin depend on view and plugin state
		 */
		canShowPlugin: function(){
			var view = this.getView();
			return !view.inFilmstripMode() || !view.get("showFilmstripSearch");
		},
		
		/**
		 * @override
		 * Set up drop down store and initial value
		 */
		startup: function() {
			const view = this.getView();
			const groupSettings = view.get("groupSettings");
			
			this.set("labelAttr", "label");
			this.set("store", view.get("filmstripPluginStore"));
			this.set("value", groupSettings.key1, false);
			
			view.watch("groupSettings", this._onWatchGroup.bind(this));
			
			return this.inherited(arguments);
		},

		/**
		 * Update widget selection based on new value
		 * @param {string} name
		 * @param {string} oldValue
		 * @param {string} newValue
		 */
		_onWatchGroup: function(name, oldValue, newValue) {
			this.set("value", newValue.key1, false);
		}
	});
});